export { SuiDimmerModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/dimmer/public.js
// module id = 1104
// module chunks = 0